export enum Gender {
  Male,
  Female
}
export type GenderIndexer<T> = {
  [id in Gender]: T;
};
